import { createRouter, createWebHistory } from 'vue-router'

import LoginView from './pages/login'
import UserView from './pages/account/user'
import EnterpriseView from './pages/account/enterprise'
import OrderView from './pages/account/order'
import PreOrderView from './pages/account/preorder'
import LeadView from './pages/account/lead'
import LeadWarningView from './pages/account/leadWarning'
import TagsView from './pages/tags'
import PortsView from './pages/ports'
import HsCodeView from './pages/hscode'
import ContainerSizeView from './pages/containerSize'
import Stat from './pages/stat'

const routes = [
  { path: '/', redirect: '/stat' },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/account/enterprise', name: 'enterprise', component: EnterpriseView },
  { path: '/account/order', name: 'order', component: OrderView },
  { path: '/account/preorder', name: 'preorder', component: PreOrderView },
  { path: '/account/lead', name: 'lead', component: LeadView },
  { path: '/account/lead-warning', name: 'leadWarning', component: LeadWarningView },
  { path: '/account/user', name: 'user', component: UserView },
  { path: '/tags', name: 'tags', component: TagsView },
  { path: '/ports', name: 'ports', component: PortsView },
  { path: '/hscode', name: 'hscode', component: HsCodeView },
  { path: '/container/size', name: 'containerSize', component: ContainerSizeView },
  { path: '/stat', name: 'stat', component: Stat },
]

export default createRouter({
  history: createWebHistory(),
  routes,
})
